import { render, staticRenderFns } from "./SearchNoResult.vue?vue&type=template&id=68e7c530&"
import script from "./SearchNoResult.vue?vue&type=script&lang=js&"
export * from "./SearchNoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports